"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESET_CONNECTION_FASTENERS = exports.REQUEST_FASTENERS_EXISTENCE_SUCCESS = exports.SET_CURRENT_CONNECTION_FASTENERS = exports.REQUEST_DEFAULT_FASTENERS_FAIL = exports.REQUEST_DEFAULT_FASTENERS_SUCCESS = void 0;
exports.REQUEST_DEFAULT_FASTENERS_SUCCESS = 'REQUEST_DEFAULT_FASTENERS_SUCCESS';
exports.REQUEST_DEFAULT_FASTENERS_FAIL = 'REQUEST_DEFAULT_FASTENERS_FAIL';
exports.SET_CURRENT_CONNECTION_FASTENERS = 'SET_CURRENT_CONNECTION_FASTENERS';
exports.REQUEST_FASTENERS_EXISTENCE_SUCCESS = 'REQUEST_FASTENERS_EXISTENCE_SUCCESS';
exports.RESET_CONNECTION_FASTENERS = 'RESET_CONNECTION_FASTENERS';
